<template>
  <div>
    <link
      href="http://img.233.com/wx/img/union/study2019/kuang.css?v=20190316"
      rel="stylesheet"
      type="text/css"
    />
    <link
      href="http://img2.233.com/wx/union/pc/fine/category/css/jiankanggls.css?v=20190316"
      rel="stylesheet"
      type="text/css"
    />
    <div class="wx-header-cont" id="wx-header-cont">
      <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
      <div class="wx-header-container">
        <div class="fl-box">
          <h1 class="logo">
            <a href="/">
              <img :src="logo" />
            </a>
          </h1>
          <div class="line"></div>
          <div class="wx-subject">
            <h2>健康管理师</h2>
            <i class="dropdown-arrow"></i>
            <div class="subject-list">
              <a href="./#/yaoshi">执业药师</a>
              <a target="_blank" href="http://wx.zezhipx.com/channel.aspx?domain=hushi">护士资格</a>
            </div>
          </div>
          <div class="head-area text-gry6 font14 fl m-t-10" style="display: none;">
            当前地区
            <p class="m-l-15 bg-white fr">
              <em class="now-area p-0-20">全国版</em>
              <a href class="more-area p-0-10">更多地区</a>
            </p>
            <div class="area_list">
              <ul>
                <li>
                  <a href="/tegang/guojia/#tgtc">全国</a>
                </li>
                <li>
                  <a href="/tegang/shanxi1/#tgtc">陕西</a>
                </li>
                <li>
                  <a href="/tegang/hebei/#tgtc">河北</a>
                </li>
                <li>
                  <a href="/tegang/henan/">河南</a>
                </li>
                <li>
                  <a href="/tegang/sichuan/#tgtc">四川</a>
                </li>
                <li>
                  <a href="/tegang/jiangxi/#tgtc">江西</a>
                </li>
                <li>
                  <a href="/tegang/yunnan/#tgtc">云南</a>
                </li>
                <li>
                  <a href="/tegang/heilongjiang/#tgtc">黑龙江</a>
                </li>
                <li>
                  <a href="/tegang/chongqing/#tgtc">重庆</a>
                </li>
                <li>
                  <a href="/tegang/hubei/#tgtc">湖北</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="fr-box">
          <!--未登录 -->
          <div class="personal-no" v-if="!isLogin">
            <p>
              <a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|
              <a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a>
            </p>
          </div>
          <div class="personal" v-else>
            <a href="javascript:;" class="pic">
              <img :src="logoSrc" />
              <i class="dropdown-arrow"></i>
            </a>
            <div class="pop-personal">
              <a href="javascript:" @click="loginout()">
                <i class="icon"></i>
                <span class="txt">退出</span>
              </a>
            </div>
          </div>
          <div class="classify">
            <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
              <p class="icon shopping"></p>
            </a>
          </div>
          <div v-if="kefu.length>0" class="wx-telephone">
            <p class="txt1">客服热线</p>
            <p class="txt2">{{kefu}}</p>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
    <!--banner-->
    <div class="bg-black">
      <!--01banner-->
      <Banner imgUrl="http://img2.233.com/wx/union/pc/fine/category/img/jiankanggls/banner01.jpg"></Banner>
      <!--01banner 结束-->
      <!---02试听区域--->
      <div class="video clearfix">
        <div class="video-layout">
          <div class="subject-tabBox clearfix">
            <ul class="sub-tabL clearfix">
              <li
                class="line"
                @click="changeCourseIndex(i)"
                v-for="(v,i) in courses"
                :key="i"
              >
                <a href="javascript: void(0)" :class="i==courseIndex?'hover':''">{{v.name}}</a>
              </li>
            </ul>
            <!-- <div
              class="Rselect-box"
              @mouseover="changeIsHoverCourse(true)"
              @mouseout="changeIsHoverCourse(false)"
            >
              <p class="subject-select currt clearfix">
                <span class="txt">选择其它科目</span>
                <i class="ico"></i>
              </p>
              <div class="sub-sel-list" v-show="isHoverCourse">
                <ul>
                  <li v-for="(v,i) in courses.slice(7)" :key="i">
                    <a
                      @click="changeCourseIndex(i+7)"
                      style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
                      href="javascript: void(0)"
                    >{{v.name}}</a>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>
          <myvideo
            :isLogin="isLogin"
            :allLoginPlayFlag="allLoginPlayFlag"
            :unionId="unionId"
            :classEname="'jiankanggls'"
            :logo="logo"
            :myClassId="courses[courseIndex].myClassId"
          ></myvideo>
        </div>
        <div class="video-bottom"></div>
      </div>
      <!---02试听区域END--->
    </div>

    <!--03原高级平台班级对比-->
    <banjiduibi :calssName="'健康管理师'" :classEName="'jiankanggls'"></banjiduibi>
    <!--03原高级平台班级对比 end-->
    <!--04全部班级表格-->
    <quanbubanji :classEname="'jiankanggls'"></quanbubanji>
    <!--04全部班级表格 end-->

    <!--06套用官网内容  开始------------->
    <!-- 考证原因 -->
    <div class="headtitle-bg why-titbg f-tac p-t-50">
      <div class="headtitle p-t-40">
        <h3 class="font48 text-sgreen">为什么要考健康管理师?</h3>
        <p class="font22 lh2 text-green">——&nbsp;&nbsp;就业前景分析指南&nbsp;&nbsp;——</p>
      </div>
    </div>
    <div class="box-wrap p-40-0 why-bg">
      <div class="why-cont lspace2 clearfix">
        <div class="box-inner box-three">
          <i class="szj"></i>
          <h4 class="font28 f-tac fb text-green">领补贴</h4>
          <p class="font18 lh2 m-t-20">
            凭资格证书，可到当地人社局领取培训
            <strong class="text-red">补贴1000-2000元</strong>。
          </p>
          <span>01</span>
        </div>
        <div class="box-inner box-three">
          <i class="szj"></i>
          <h4 class="font28 fb f-tac text-green">加积分</h4>
          <p class="font18 lh2 m-t-20">
            凭健康管理师证书可增加积分，助你拿到所居住
            <strong class="text-red">城市的绿卡</strong>。
          </p>
          <span>02</span>
        </div>

        <div class="box-inner box-three">
          <i class="szj"></i>
          <h4 class="font28 fb f-tac text-green">评职称</h4>
          <p class="font18 lh2 m-t-20">
            健康管理师证书是
            <strong class="text-red">调级、评职称</strong>的重要证书依据。
          </p>
          <span>03</span>
        </div>

        <div class="box-inner box-two">
          <h4 class="font28 fb f-tac text-green">行业前景好</h4>
          <p class="font18 lh2 m-t-20">老龄化、亚健康群体日渐庞大，专业的健康管理人才需求将超过2000万以上。</p>
          <span>04</span>
        </div>

        <div class="box-inner box-two">
          <h4 class="font28 fb f-tac text-green">就业方向广</h4>
          <p class="font18 lh2 m-t-20">健康管理师适用于医院、公司、各类机构。自主创业，健康产业盈利更丰厚。</p>
          <span>05</span>
        </div>
      </div>
    </div>
    <!-- 考证原因end -->

    <!-- 老师介绍 -->
    <div class="headtitle-bg teacher-titbg f-tac p-t-30">
      <div class="headtitle p-40-0 f-tac">
        <!--<p class="text-bg">HEATHMANAGER</p>-->
        <h3 class="text-sgreen font48">专业师资·为学习之路保驾护航</h3>
      </div>
    </div>
    <div class="box-wraper teacher-bg">
      <div class="box-inner-teacher clearfix">
        <div class="teacher-img">
          <img src="http://img2.233.com/wx/union/pc/fine/category/img/jiankanggls/health_teacher.png" alt />
        </div>
        <div class="teacher-txt font16">
          <h4 class="font38 text-green m-b-20">
            <span class="fb">姜雅</span>
            <span class="m-l-10 font24">老师</span>
          </h4>
          <p
            class="m-b-20 lh16"
          >清华大学医学部（北京协和医学院）博士毕业，现为协和医学院副教授。从事药物及其相关专业学习和研究十多年，主讲执业药师，乡村全科，健康管理师等课程，具有丰富的教学经验</p>
          <p class="lh16">授课特色：讲课娓娓道来，专业功底强，直击考试重点，结合实例讲解通俗易懂又有趣。</p>
        </div>
        <p class="teacher-txtbg"></p>
      </div>
      <div class="box-inner-teacher m-t-20 clearfix">
        <div class="teacher-img">
          <img src="http://img2.233.com/wx/union/pc/fine/category/img/jiankanggls/health_teacher1.png" alt />
        </div>
        <div class="teacher-txt font16">
          <h4 class="font38 text-green m-b-20">
            <span class="fb">王思露</span>
            <span class="m-l-10 font24">老师</span>
          </h4>
          <p
            class="m-b-20 lh16"
          >国家高级营养培训师、国家高级食品检验师、食品质量与安全专业学士、国家二级公共营养师、中华人民共和国HACCP食品体系内部审员、首都保健营养美食学会理事、电视健康节目特约营养嘉宾</p>
          <p class="lh16">授课特色：讲课娓娓道来，专业功底强，直击考试重点，结合实例讲解通俗易懂又有趣。</p>
        </div>
        <p class="teacher-txtbg"></p>
      </div>
    </div>
    <!-- 老师介绍end -->

    <!--06套用官网内容  end------------->
    <!--05服务特色标题-->
    <div class="main-title f-tac m-b-30 p-t-50">
      <p class="font-bg">CHARACTERISTIC</p>
      <h2 class="font44 fb">
        选择我们的
        <em class="text-red fb">四大理由</em>
      </h2>
      <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
    </div>
    <div class="fuwu-bg">
      <div class="fuwu-content">
        <div class="fuwu-box">
          <ul class="clearfix m-b-20">
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">1</span>课程品质高
              </h4>
              <p class="font15 lh2 p-15">
                课程专业的教研团队精心打造，
                <em class="text-red fb">每个课程均经过20+次以上迭代</em>。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">2</span>老师实力强
              </h4>
              <p class="font15 lh2 p-15">
                网校执行严格的
                <em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">3</span>学习服务优
              </h4>
              <p class="font15 lh2 p-15">
                您在学习课程中遇到任何问题，可在线提问，专业老师
                <em class="text-red fb">24小时内为您答疑解惑</em>。
              </p>
            </li>
            <li>
              <h4 class="f-tac fb font24 m-b-20">
                <span class="m-r-5 bg-sblue">4</span>售后服务好
              </h4>
              <p class="font15 lh2 p-15">
                部分套餐课程享
                <em class="text-red fb">超长有效期</em>，课程有效期内考试
                <em class="text-red fb">不过免费重学</em>保障。
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--05服务特色 end-->

    <!--10新人优惠券-->
    <div class="z-swimnavb" style=" display:none;">
      <div class="z-main z-xxhl clearfix">
        <div class="z-thjj clearfix">
          <div class="z-jjpople"></div>
          <div class="z-bmth">
            <span>注册报名限时特惠</span>
          </div>
        </div>
        <ul class="z-yhqpy clearfix">
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money">
                  <i>￥</i>150
                </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满1200可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money">
                  <i>￥</i>60
                </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满600可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money">
                  <i>￥</i>30
                </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满400可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
          <li>
            <a href="javascript:;" onclick="wxft2017.toReg();">
              <p>
                <span class="z-yhq-money">
                  <i>￥</i>10
                </span>
                <span class="z-yhq-condition">
                  优惠券
                  <br />满200可用
                </span>
              </p>
              <em>立即领取</em>
            </a>
          </li>
        </ul>
        <div class="z-cha"></div>
      </div>
    </div>
    <!--10新人优惠券 end-->
  </div>
</template>
<script>
import myvideo from "@/components/myvideo";
import banjiduibi from "@/components/banjiduibi";
import quanbubanji from "@/components/quanbubanji";
import { getMemberPicpath } from "@/request/request.js";
export default {
  name: "App",
  components: {
    banjiduibi,
    quanbubanji,
    myvideo,
  },
  data() {
    return {
      laoshiindex: 0,
      isLogin: false,
      logoSrc: "",
      allLoginPlayFlag: false,
      unionId: "",
      kefu: "",
      logo: "",
      href: "",
      courses: [
        { name: "三级专业技能", myClassId: 31844 },
      ],
      courseIndex: 0,
      isHoverCourse: false,
    };
  },
  created() {
    this.href = encodeURIComponent(window.location.href);
    var config = JSON.parse(
      sessionStorage.getItem(window.location.host + "puconfig")
    );
    if (config.KefuTelList.length > 0) {
      this.kefu = config.KefuTelList[0].KefuNumber;
    }
    this.unionId = config.UnionId;
    this.logo = config.UnionLogo;
    this.allLoginPlayFlag = config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if (token != undefined) {
      this.isLogin = true;
      getMemberPicpath({}, (res) => {
        this.logoSrc = res;
      });
    } else {
      var interval = setInterval(() => {
        token = localStorage.getItem("usertoken");
        if (token != undefined) {
          this.isLogin = true;
          getMemberPicpath({}, (res) => {
            this.logoSrc = res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods: {
    loginout() {
      this.isLogin = false;
      this.logoSrc = "";
      localStorage.removeItem("usertoken");
    },
    scroll(num) {
      document.documentElement.scrollTop = num;
    },
    changeCourseIndex(i) {
      this.courseIndex = i;
    },
    changeIsHoverCourse(flag) {
      this.isHoverCourse = flag;
    },
    changehoverindex(i) {
      this.hoverindex = i;
    },
    changelaoshiindex(i) {
      this.laoshiindex = i;
    },
  },
};
</script>
